module.exports = __webpack_public_path__ + "fonts/montserrat-regular-webfont.8f2822b73b5f9c106c6f2e0db820bcbb.woff?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/font/montserrat-regular-webfont.woff
// module id = 717
// module chunks = 9